/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeDatepickerPlaceholderByCulture } from '@/components/EpDatepicker/utils/takeDatepickerPlaceholderByCulture';
import { IUseDatepickerMaskProps } from '@/interfaces';
import { convertDateToTheFormatMMDDYYYY } from '@/utils/convertDateToTheFormatMMDDYYYY';
import { IMask, useIMask } from 'react-imask';

export function useDatepickerMask({
  cultureCode,
  instanceRef,
  maxDate,
  maskOpts,
}: IUseDatepickerMaskProps) {
  const dateFormatByCultureCode =
    cultureCode === 'en' || cultureCode === 'en-US'
      ? 'MM/DD/YYYY'
      : 'DD/MM/YYYY';
  const { placeholderPattern, placeholderYearChar, placeholderFormat } =
    takeDatepickerPlaceholderByCulture(cultureCode);
  const options = {
    mask: Date,
    pattern: placeholderPattern,
    blocks: {
      d: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 31,
        maxLength: 2,
        placeholderChar: 'D',
      },
      m: {
        mask: IMask.MaskedRange,
        from: 1,
        to: 12,
        maxLength: 2,
        placeholderChar: 'M',
      },
      [placeholderYearChar]: {
        mask: IMask.MaskedRange,
        from: 1900,
        to: 2999,
        maxLength: 4,
        placeholderChar: placeholderYearChar,
      },
    },
    format: (date: string) => {
      const objectDate = new Date(date);
      let day: string | number = objectDate.getDate();
      let month: string | number = objectDate.getMonth() + 1;
      const year: string | number = objectDate.getFullYear();

      if (day < 10) day = '0' + day;
      if (month < 10) month = '0' + month;

      const formattedDate: any = {
        'DD-MM-AAAA': [day, month, year].join('-'),
        'MM/DD/YYYY': [month, day, year].join('/'),
        default: [day, month, year].join('/'),
      };

      return formattedDate[placeholderFormat] ?? formattedDate.default;
    },
    parse: (str: string) => convertDateToTheFormatMMDDYYYY(str, dateFormatByCultureCode),
    lazy: false,
    overwrite: true,
    ...maskOpts,
  };

  const iMask = useIMask(options, {
    onComplete: (value: string) => {
      if (!instanceRef) return;
      const convertedDate = new Date(
        convertDateToTheFormatMMDDYYYY(value, dateFormatByCultureCode),
      );
      instanceRef.current?.selectDate(convertedDate);

      if (maxDate && convertedDate > maxDate) {
        instanceRef.current?.setViewDate(new Date());
        return;
      }

      instanceRef.current?.setViewDate(convertedDate);
    },
  });

  return { iMask, dateFormatByCultureCode, placeholderFormat };
}
